module.exports = __webpack_public_path__ + "img/northeast-fall-544x667.2ca69b9e.jpg";